import { render } from "./DemoControls.vue?vue&type=template&id=5435406c&scoped=true"
import script from "./DemoControls.vue?vue&type=script&lang=js"
export * from "./DemoControls.vue?vue&type=script&lang=js"

import "./DemoControls.vue?vue&type=style&index=0&id=5435406c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5435406c"]])

export default __exports__